import { useGetOne } from 'react-admin';

export function useNextCharges(userId) {
  return useGetOne(`users/${userId}`, { id: 'next-charges' }, { enabled: !!userId });
}
